









import { defineComponent, getCurrentInstance } from "vue";
import getCurrentView from "@/composition/getCurrentView";
import useMatomoEvent from "@/composition/useMatomoEvent";

export default defineComponent({
  setup() {
    const root = getCurrentInstance();
    function clearSelection() {
      root.proxy.$store.commit("collaboration/clearSelection");

      useMatomoEvent({
        category: `${getCurrentView()} View`,
        action: 'Click "Abbrechen"',
        name: `Abbrechen Collab in ${getCurrentView()}-View`
      });
    }
    return { clearSelection };
  }
});
